import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface CommonLogState {
  commonLogList?: any
}

const initialState: CommonLogState = {
  commonLogList: {},
}

export const commonLogDucks = createSlice({
  name: 'categorie',
  initialState,
  reducers: {
   
    getListCommonLog: (state: RootState, action: PayloadAction<any>) => {
      state.commonLogList = { loading: true, queryStr: action.payload }
    },
    getListCommonLogSuccess: (state, action: PayloadAction<any>) => {
      state.commonLogList = { loading: false, ...action.payload }
    },
    getListCommonLogFail: (state, action: PayloadAction<any>) => {
      state.commonLogList = { loading: false, ...action.payload }
    },
    
    
  },
})

// Action creators are generated for each case reducer function
export const {
  getListCommonLog,
  getListCommonLogSuccess,
  getListCommonLogFail,
} = commonLogDucks.actions

export default commonLogDucks.reducer
